import Indicator, { IndicatorType } from '../../types/Indicator'

const ThinBlue: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'thinBlue',
  label: 'Thin Blue',
  fields: ['thinBlue'],
  excludeSelfInRHS: true,
}

export default ThinBlue
